module.exports = __webpack_public_path__ + "img/New Zealand.b03beded.svg";